import { Save } from "lucide-react";
import Select from "react-select";
import React, { useEffect, useRef, useState } from "react";
import Spacing from "../Spacing";
import DropdownWithSearch from "../DropdownWithSearch";
import { useSelector } from "react-redux";
import { can_visit, getPractice, getSecureData, notify } from "../../helpers";
import { Drawer } from 'vaul';
import Button from "../UI/Button";
export default function EditUserModal({
  allProviders = [],
  onClose = () => {},
  userData = {},
  handleDelete = () => {},
  handleUpdatedInvitedUserInfo = () => {},
  userRoles = [],
  editInvitationModal = false
}) {
  const [validateInput, setValidateInput] = React.useState(false);
  const userProfileData = useSelector((state) => state.practice.userProfile);
  const [allProvidersOptions, setAllProvidersOptions] = useState([]);
  const dropdownRef = useRef(null);
  const [loading, setLoading] = React.useState(false);

  const [invitedUserData, setInvitedUserData] = useState({
    invitation_id: userData?.id || "",
    email: userData?.recipient_email || "",
    roles: userData?.roles || [],
    groups: userData?.groups || [],
    linked_providers: userData?.linked_providers || [],
  });

  // useEffect(() => {
  //   setInvitedUserData({     
  //     linked_providers: userData?.linked_providers || [],
  //   });
  // }, [userData]);
  
  const getAllProviders = () => {
    try {     

      if (allProviders?.length) {
        const allProvidersFormatted = allProviders?.map((option) => ({
          value: option?.provider_id,
          label: `${option?.first_name} ${option?.last_name}`,
        }))
        setAllProvidersOptions(allProvidersFormatted);
      };
    } catch (error) {
      // console.log("🚀 ~ getAllProviders: ~ error:", error);
    }
  };

  useEffect(() => {
    getAllProviders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleLinkedProvidersChange = (selectedOption) => {
    const selectedValues = selectedOption ? selectedOption?.map((option) => option?.value) : [];
    setInvitedUserData({
      ...invitedUserData,
      linked_providers: selectedValues,
    });
  };

  const handleChangeRoles = (value) => {
    setInvitedUserData({
      ...invitedUserData,
      roles: invitedUserData?.roles?.includes(value)
        ? invitedUserData?.roles?.filter((role) => role !== value)
        : [...invitedUserData?.roles, value],
    });
  };

  const handleSelectGroup = (account) => {
    const accountKey = `/${account?.practices[0]?.account_name}`;
    const practiceKeys = account.practices.map((practice) => `${accountKey}/${practice.name}`);
  
    setInvitedUserData((prevData) => {
      const isAccountSelected = prevData.groups.includes(accountKey);

      if (isAccountSelected) {
        return {
          ...prevData,
          groups: prevData.groups.filter(
            (group) => group !== accountKey && !practiceKeys.includes(group)
          ),
        };
      }

      return {
        ...prevData,
        groups: [...new Set([...prevData.groups, accountKey, ...practiceKeys])],
      };
    });
  };
  

  const handleChangePractices = (practiceName, accountName) => {
    const practiceKey = `/${accountName}/${practiceName}`;
    const accountKey = `/${accountName}`;
  
    setInvitedUserData((prevData) => {
      const isPracticeSelected = prevData?.groups?.includes(practiceKey);

      if (isPracticeSelected) {
        const updatedGroups = prevData?.groups?.filter((group) => group !== practiceKey);

        const hasRemainingPractices = updatedGroups?.some((group) =>
          group.startsWith(`${accountKey}/`)
        );
        return {
          ...prevData,
          groups: hasRemainingPractices
            ? updatedGroups
            : updatedGroups?.filter((group) => group !== accountKey),
        };
      }

      return {
        ...prevData,
        groups: [...new Set([...prevData?.groups, practiceKey, accountKey])],
      };
    });
  }; 

  const handleInviteUserUpdate = () => {
    if(invitedUserData?.groups?.length === 0){
      notify("error", "Please select at least one practice", 5);
      return;
    }

    if(invitedUserData?.roles?.length === 0){
      notify("error", "Please select at least one role", 5);
      return;
    }

    if(invitedUserData?.email === ""){
      notify("error", "Please enter email address", 5);
      return;
    }
    setLoading(true);
    handleUpdatedInvitedUserInfo(invitedUserData, () => {
      setLoading(false);
      onClose();
    });
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={editInvitationModal} onOpenChange={onClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 medium">
            <Drawer.Title className="sr-only">Edit Invitation</Drawer.Title>
            <Drawer.Description className="sr-only">Edit an invitation</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_auto">
              <div className="docpro_modal">
                <h2 className="docpro_fs_24">Edit user invitation info</h2>

                <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_1">
                  <div className="docpro_grid_item">
                    <label className="docpro_fw_500 docpro_primary_color">
                      Email <span className="docpro_red_color">*</span>
                    </label>
                    <input
                      type="text"
                      value={userData?.recipient_email || ""}
                      className="docpro_form_field size_lg"
                      disabled
                    />
                  </div>
                  <div className="docpro_grid_item">
                    <label className="docpro_fw_500 docpro_primary_color">Role <span className="docpro_red_color">*</span></label>
                    <DropdownWithSearch
                      placeholder={
                        (invitedUserData?.roles && invitedUserData?.roles?.length)
                          ? `${invitedUserData?.roles?.join(", ")}`
                          : "Select Roles"
                      }
                    >
                      <ul className="docpro_checkmark_list">
                        {(can_visit("administrator") ? userRoles : userRoles?.filter(
                            (role) => !["Trial", "System", "Enterprise"].includes(role)
                          ))?.map((item, index) => (
                            <li key={index}>
                              <div className="docpro_checkbox" style={{ top: "3px" }}>
                                <input
                                  type="checkbox"
                                  checked={invitedUserData?.roles?.includes(item)}
                                  onChange={() => handleChangeRoles(item)}
                                />
                                <label>
                                  <span style={{ marginLeft: "8px" }}>{item}</span>
                                </label>
                              </div>
                            </li>
                          )
                        )}
                      </ul>
                    </DropdownWithSearch>
                  </div>

                  <div className="docpro_grid_item">
                    <label className="docpro_fw_500 docpro_primary_color">
                      Practices <span className="docpro_red_color">*</span>
                    </label>
                    <DropdownWithSearch
                      placeholder={
                        invitedUserData?.groups?.length
                          ? `${invitedUserData?.groups?.join(", ")}`
                          : "Select Practices"
                      }
                      isErrorState={validateInput && !invitedUserData?.groups?.length}
                    >
                      {userProfileData?.accounts?.map((account, index) => (
                        <div key={index}>
                          <li style={{ listStyle: "none", margin: "10px 0px" }}>
                            <div
                              className="docpro_checkbox"
                              style={{ top: "3px" }}
                            >
                              <input
                                type="checkbox"
                                onChange={() => handleSelectGroup(account)}
                                checked={invitedUserData?.groups?.includes(
                                  `/${account?.practices[0]?.account_name}`
                                )}
                              />
                              <label>
                                <span style={{ marginLeft: "8px" }}>
                                  {account?.practices[0]?.account_name}
                                </span>
                              </label>
                            </div>
                          </li>
                          {account.practices.map((practice) => {
                            const practiceKey = `/${account?.practices[0]?.account_name}/${practice.name}`;
                            return (
                              <li
                                key={practice?.location_id}
                                style={{ listStyle: "none", paddingLeft: "15px" }}
                              >
                                <div
                                  className="docpro_checkbox"
                                  style={{ top: "3px" }}
                                >
                                  <input
                                    type="checkbox"
                                    onChange={() => handleChangePractices(practice?.name, account?.practices[0]?.account_name)}
                                    checked={invitedUserData?.groups?.includes(practiceKey)}
                                  />
                                  <label>
                                    <span style={{ marginLeft: "8px" }}>
                                      {practice?.name}
                                    </span>
                                  </label>
                                </div>
                              </li>
                            )
                          })}
                        </div>
                      ))}
                    </DropdownWithSearch>
                  </div>

                  {allProvidersOptions?.length > 0 && (
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Linked Providers
                      </label>
                      <Select
                        isMulti
                        name="linked_providers"
                        options={allProvidersOptions}
                        placeholder="Search..."
                        isSearchable
                        value={allProvidersOptions?.filter((option) => 
                          invitedUserData?.linked_providers?.includes(option?.value)
                        ) || []}
                        onChange={(selectedOption) => handleLinkedProvidersChange(selectedOption)}
                        className="react-select-container w-full"
                        classNamePrefix="react-select"                        
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: '40px',
                            borderColor: 'var(--border)',
                            borderRadius: '8px'
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 1050,
                            marginTop: '-2px',
                            borderRadius: '0 0 3px 3px',
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 1050,
                            padding: 0
                          }),
                        }}
                      />
                    </div>
                  )}
                  
                 
                  
                  
                </div>
                <Spacing lg="32" sm="32" />
                <div className="docpro_modal_btns small_buttons docpro_mt_auto">
                  <button
                    className="docpro_bordered_btn docpro_fw_600 size_lg"
                    onClick={onClose}
                  >
                    Cancel
                  </button> 
                  <Button filled lg loading={loading} onClick={handleInviteUserUpdate}>
                  <Save width={20} height={20} /> Update
                  </Button>                 
                  
                </div>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
